module.exports = __webpack_public_path__ + "img/dia_do_consumidor.1b64e2bb.svg";